// extracted by mini-css-extract-plugin
export default {"dynamicTitleWrapper":"styles_dynamicTitleWrapper__LaS42","fadeInOut":"styles_fadeInOut__iYGIF","fadeIn":"styles_fadeIn__u93TW"};